var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86495 1.75507L7.74495 3.51507C7.86495 3.76007 8.18495 3.99507 8.45495 4.04007L10.05 4.30507C11.07 4.47507 11.31 5.21507 10.575 5.94507L9.33495 7.18507C9.12495 7.39507 9.00995 7.80007 9.07495 8.09007L9.42995 9.62507C9.70995 10.8401 9.06495 11.3101 7.98995 10.6751L6.49495 9.79007C6.22495 9.63007 5.77995 9.63007 5.50495 9.79007L4.00995 10.6751C2.93995 11.3101 2.28995 10.8351 2.56995 9.62507L2.92495 8.09007C2.98995 7.80007 2.87495 7.39507 2.66495 7.18507L1.42495 5.94507C0.694954 5.21507 0.929955 4.47507 1.94995 4.30507L3.54495 4.04007C3.80995 3.99507 4.12995 3.76007 4.24995 3.51507L5.12995 1.75507C5.60995 0.800068 6.38995 0.800068 6.86495 1.75507Z",
    fill: "#FFAD11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.93825553229e0586cb614b8eccc597bd.svg";
export { ForwardRef as ReactComponent };